<template>
  <main class="container d-flex flex-column justify-content-center px-3">
    <slot></slot>

    <img
      class="mt-4 card-img"
      :src="useAsset('img/credit-line/credit-card/tilted-card.svg')"
      alt="card-img"
    />

    <div class="footer mt-2">
      <div
        class="w-100 d-flex justify-content-center mb-4"
        @click="emit('linkClick')"
      >
        <p class="redirect-link">
          <span class="text-center w-100">{{ linkText }}</span>
        </p>
      </div>
      <Button
        v-if="showActionButton"
        @click="emit('btnClick')"
        class="mb-3 w-100"
      >
        <img
          class="text-white mb-1"
          :src="useAsset('img/credit-line/credit_card_white.svg')"
          alt="pc svg"
        />
        <span class="text-center ms-2">{{ buttonText }}</span>
      </Button>
    </div>
  </main>
</template>

<script setup lang="ts">
import Button from "@/apps/credit-line/components/Button.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";

defineProps({
  buttonText: String,
  linkText: String,
  showActionButton: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["btnClick", "linkClick"]);
</script>

<style lang="scss" scoped>
Button {
  border-radius: 0.625rem;
  background: var(--main-primary-500, #2c7040);
  width: 100%;
  height: 2.75rem;
  padding: 0.625rem 1rem;

  & {
    font-family: "Inter", sans-serif;
  }
}

.card-img {
  width: 80%;
  height: auto;
  margin-left: 10%;
}

.redirect-link {
  color: #2c7040;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, sans-serif;
  font-size: 1rem;
  font-style: semi-bold;
  font-weight: 600;
  text-decoration: none;
}
</style>
